var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGeoZoomIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.358 8.133H4.945a.86.86 0 0 1-.633-.256.86.86 0 0 1-.256-.633c0-.252.085-.463.256-.633a.86.86 0 0 1 .633-.255h1.413V4.944a.86.86 0 0 1 .255-.634.86.86 0 0 1 .634-.255.86.86 0 0 1 .633.255.86.86 0 0 1 .255.634v1.412h1.413a.86.86 0 0 1 .633.256.86.86 0 0 1 .256.633.859.859 0 0 1-.256.633.86.86 0 0 1-.633.255H8.135v1.412a.86.86 0 0 1-.255.634.86.86 0 0 1-.634.255.86.86 0 0 1-.633-.255.86.86 0 0 1-.255-.634V8.133zm.888 6.356c-2.025 0-3.739-.701-5.142-2.103C.701 10.984 0 9.27 0 7.246c0-2.024.701-3.738 2.104-5.141C3.506.702 5.22 0 7.244 0c2.025 0 3.74.701 5.143 2.104 1.404 1.402 2.106 3.116 2.106 5.14a6.95 6.95 0 0 1-.426 2.425 6.775 6.775 0 0 1-1.137 2.009l6.818 6.816c.164.164.248.37.252.619a.838.838 0 0 1-.252.63.85.85 0 0 1-.625.257.85.85 0 0 1-.624-.257l-6.818-6.817a6.774 6.774 0 0 1-2.044 1.148 7.024 7.024 0 0 1-2.39.415zm0-1.777c1.527 0 2.82-.53 3.88-1.589 1.06-1.06 1.59-2.352 1.59-3.879 0-1.526-.53-2.819-1.59-3.878-1.06-1.06-2.353-1.59-3.88-1.59-1.526 0-2.82.53-3.88 1.59-1.059 1.06-1.589 2.352-1.589 3.878 0 1.527.53 2.82 1.59 3.88 1.06 1.059 2.353 1.588 3.88 1.588z",
    fill: "#626266",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeoZoomIn);
export default __webpack_public_path__ + "static/media/geo-zoom-in.fc5dc99f38bfa139000fd2e41fbe7727.svg";
export { ForwardRef as ReactComponent };